export function appBarBackgroundFromEnv(envUrl: string): string {
    const win = globalThis.window;
      const isStageVpHost =
    typeof win !== "undefined" &&
    (win.location.hostname === "portal-stage.facilitiesgroup.com");
  if (envUrl.includes("portal-stage.facilitiesgroup.com")|| isStageVpHost) {
    return "#e06c24";
  }

  const isDemoVpHost =
    typeof win !== "undefined" &&
    (win.location.hostname === "demo-vp.idsbeta.com");
  if (envUrl.includes("demo-vp.idsbeta.com") || isDemoVpHost) {
    return "#9A58B5";
  }
  const isLocalhost3001 =
    typeof win !== "undefined" && win.location.host === "localhost:3001";
  if (envUrl.includes("localhost:3001") || isLocalhost3001) {
    return "#5ce600";
  }
  return "primary";
}
